// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2525":"2ecf369a","3100":"ac140744","3567":"2ecf369a","4121":"2ecf369a","9613":"2ecf369a"}[chunkId] + ".chunk.css";
};